import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "./useAuth";

export function useAzureLogin() {
	const navigate = useNavigate();
	const location = useLocation();
	const { getUser, consumeStoredDestination } = useAuth();
	const hasRedirected = useRef(false);

	useEffect(() => {
		if (location.pathname === "/auth/callback") return;
		if (hasRedirected.current) return;

		const existingUser = getUser();
		if (existingUser) {
			hasRedirected.current = true;
			navigate(consumeStoredDestination(existingUser.role), { replace: true });
		}
	}, [consumeStoredDestination, getUser, location.pathname, navigate]);
}
